import { render, staticRenderFns } from "./LedgerBankForm.vue?vue&type=template&id=322c826b&"
import script from "./LedgerBankForm.vue?vue&type=script&lang=js&"
export * from "./LedgerBankForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports